'use strict';

app.config(function ($stateProvider) {

  $stateProvider.state('instance.app.module.lesson.introduction', {
    url: '/introduction',
    templateUrl: '/app/states/module/lesson/introduction/introduction.html',
    controller: function ($scope, $state, Api, lesson, rmGuide) {
      $scope.showTutorial = _.get($scope.instance, 'tutorial.enabled', false);
      $scope.isTutorialViewed = function (id) {
        return rmGuide.isViewed(id);
      };
      $scope.onNotificationDismiss = function () {
        rmGuide.markViewed($scope.lesson.tutorial.id);
      };
      lesson.activeByte = lesson.introduction;
      Api.track('module.lesson.introduction', 'view');
      $scope.next = function () {
        Api.track('module.lesson.introduction', 'pass').then(function () {
          if (lesson.learningBytes.length) {
            $state.go('^.byte', { byteId: lesson.learningBytes[0]._id }, { reload: true });
          } else {
            $state.go('^.recap', {}, { reload: true });
          }
        });
      };
    }
  });

});
